import EditUpcomingInvoiceDetails from './EditUpcomingInvoiceDetails.page';

export default EditUpcomingInvoiceDetails;
